export default __webpack_public_path__ + "static/media/increasefont.a0950198.svg";